document.addEventListener('DOMContentLoaded', () => {
    const formContainer = document.querySelector('.section-contact');

    const observer = new MutationObserver((mutationsList, observer) => {
        const form = document.querySelector('form-embed');

        if (form) {
            observer.disconnect();
            const shadow = form.shadowRoot;

            const sheet = new CSSStyleSheet();
            sheet.insertRule(`
              section[data-testid=form-container] {
                max-width: unset!important;
              }
            `);
            sheet.insertRule(`
              form {
                gap: .8rem!important;
                padding: 0!important;
              }
            `);
            sheet.insertRule(`
              input, textarea {
                border-radius: 0 !important;
                border: none !important;
                box-shadow: none !important;
                background-color: #F9F8F7!important;
              }
            `);
            sheet.insertRule(`
                textarea {
                  min-height: 200px !important;
                }
            `);
            sheet.insertRule(`
                button {
                  border-radius: 0 !important;
                  padding: 24px 32px;
                }
            `);

            shadow.adoptedStyleSheets.push(sheet);
            formContainer.classList.add('loaded');
        }
    });

    observer.observe(document.body, {childList: true, subtree: true});
});